import { i18n } from "../i18n";
import { goDateString, dateToTimeString, readSlots, isQueryParamTrue } from "./common";
import { SLOT_TYPES } from "./models";
import { getTableStartDate, handleNewSlotInTable, initTable, resizeSlotDOMElementsForUser, handleRawSlotChange, handleSlotDelete as onSlotDelete, handleLinkedSlotsStats, roleStore } from "./summary_dws_table";
import * as draw from "./summary_dws_draw";
import { transformCompany } from "./transformers";
import { initSlotModalRoleListComponent, getAndUpdateRolesList } from "../slotModal/roleList";
import { updateSlotUnreadCommentBadge } from "./slotLog";
import { createApp, ref, readonly } from "vue";
import AutoModal from "../vue/AutoModal.vue";
import SummaryDateNavView from "../view/components/summaryDateNav/SummaryDateNavView.vue";
import { MODAL_ID } from "./enums/modal_types";
import { MeStore } from "../store/v1/meStore";
import { User } from "../model/v1/user";
import { disableAutoUndoButton, initAutoUndoButton } from "./summary_dws_auto";
import { summaryDwsRoleSectionBulkDelete, summaryUndoDwsAuto } from "../requests/summaryDwsAuto";
import { mountAutoAIModal, setMeStore } from "./summary_lib";
import { initDwsCellEdit } from "../summaryTable/dwsTableEditMode";
import { initFooterAutoButtonClick } from "../view/components/autoAI/autoai_poll";
import ERRORS from "./errors";
import { fromOplusTime, sortTags, yearMonthDateString } from "../common/common";
import { DateTime } from "luxon";
import { initFooterDropdownHandlers } from "./summary_footer";
import { dateNavViewModelInjectKey } from "../provider/provider";
import periodTypes from "../table/v1/periodTypes";
import { getPageSlotURL } from "./slot_crud_requests";
import { initUndoButton, saveCreatedSlotForUndo, saveDeletedSlotForUndo } from "../summaryTable/summaryDwsUndo";

export { handleFooterBtnClick } from "./summary_footer";

export function observeSidebar() {
  const sidebar = $("#sidebar")[0];
  const sidebarObserver = new ResizeObserver(() => { resizeSlots(); });
  sidebarObserver.observe(sidebar);
}
let canEdit = false;
let useShiftBorders = false;
let activeCompany = {};
let activeUserId = 0;
let slotUrl = "";
let isUsingRequestSlots = false;
export let userIds = [];

const deleteMode = {
  isOn: false,
  selectedIds: {},
}

//createRestSectionMapFromSlot creates a map where the keys are hours that the slot has a rest section that lasts the entire hour. Returns an object.
export function createRestSectionMapFromSlot(slot) {
  const restSectionMap = {};
  if (slot.Sections) {
    slot.Sections.forEach(sectionId => {
      const section = SlotMap[sectionId];
      // If you change roles in the slot modal, sections are not returned and we hard refresh.
      if (!section) {
        return;
      }
      const sectionFrom = new Date(section.From);
      const sectionTo = new Date(section.To);
      const isAnHourOrLonger = (sectionTo - sectionFrom) >= 3600000;
      //if the section is rest type and the rest is an hour or more, then add to rest map
      if (section.Type === SLOT_TYPES.SECTION_REST && isAnHourOrLonger) {
        //round Start to nearest hour equal or later
        if (sectionFrom.getUTCMinutes() !== 0) {
          sectionFrom.setUTCHours(sectionFrom.getUTCHours() + 1, 0, 0, 0);
        }
        // round To to nearest hour equal or earlier
        if (sectionTo.getUTCMinutes() !== 0) {
          sectionTo.setUTCHours(sectionTo.getUTCHours(), 0, 0, 0);
        }

        do {
          restSectionMap[sectionFrom] = true;
          sectionFrom.setUTCHours(sectionFrom.getUTCHours() + 1, 0, 0, 0);
        } while (sectionFrom < sectionTo)
      }
    });
  }

  return restSectionMap;
}

// Pass thru function for template
export function handleSlotChange(rawSlot) {
  handleRawSlotChange(rawSlot);
}

// Pass thru interface for template
export function handleStatsLinked(linkedSlots) {
  handleLinkedSlotsStats(linkedSlots);
}

// Pass thru function for template
export function handleSlotDelete(rawSlot) {
  onSlotDelete(rawSlot);
}

export function handleNewSlot(rawSlot, dropCancel = false) {
  if (rawSlot.RequestedSlot) {
    $(`#slot-${rawSlot.RequestedSlot.ID}`).remove();
  }
  if (!dropCancel) {
    $(`#slot-${rawSlot.ID}`).remove();
  }

  handleNewSlotInTable(rawSlot, canEdit, getUsername(rawSlot.UserID));
}

export function handleNewSlotUndo(rawSlot) {
  saveCreatedSlotForUndo(rawSlot, isUsingRequestSlots);
}

export function handleDeletedSlotUndo(rawSlot) {
  saveDeletedSlotForUndo(rawSlot, isUsingRequestSlots);
}

export function deleteSlotFromMap(slotID) {
  SlotModal.onDelete(slotID);
}

export function addSlotToMapAndTable(slot) {
  SlotMap[slot.ID] = slot;
  handleSlotChange(slot);
  handleNewSlot(slot);
}

// handle help select input change on slot modal
export function handleHelpBranchChange(branchId) {
  let selectedBranchId = branchId
  // if no branchId value, we fetch the active branch instead
  if (!branchId) {
    selectedBranchId = activeCompany.ID;
  }
  getAndUpdateRolesList(selectedBranchId);
  return;
}

export function displayTimeRangeTooltip(element, fromString, toString) {
  element.addClass(["tooltip", "tooltip-bottom"]);
  element.attr("data-tooltip", `${fromString} ~ ${toString}`);
}

// createPutData and createSectionPutData makes the data object needed for a slot put after drag or resize
export function createPutData(slot, from, to, userId) {
  return {
    "askStatus":slot.AskStatus,
    "color":slot.Color,
    "date": goDateString(from),
    "from": dateToTimeString(from),
    "locked":slot.Locked,
    "purpose":slot.Purpose,
    "rest":slot.Rest,
    "to": dateToTimeString(to),
    "type":slot.Type,
    "userID": userId,
    "roleID":slot.RoleID,
    "memo": slot.Memo,
  };
}

export function createSectionPutData(slot, from, to) {
  return {
    "from": dateToTimeString(from),
    "to": dateToTimeString(to),
    "comID": slot.CompanyID,
    "parent": slot.SectionParent,
    "purpose": slot.Purpose,
    "roleID": slot.RoleID,
    "color": slot.Color,
    "date": slot.Date,
    "type": slot.Type,
    "locked": false,
    "rest": "",
    "restSection": slot.Type === SLOT_TYPES.SECTION_REST,
    "sendEmail": false,
    "fromDate": getTableStartDate(),
    "memo": slot.Memo,
  }
}

function getUsername(userId) {
  return App.userMap[userId].username;
}

// getSlotUrl is the getter for the pipeline value {{ .slotURL }}
export function getSlotUrl() {
  return slotUrl;
}

// getActiveUserId is the getter for the pipeline value {{ .User.ID }}
export function getActiveUserId() {
  return activeUserId;
}

//getIsComUsingRequestSlots is the getter for the pipeline value {{ .com.StackRequestSlots }}
export function getIsComUsingRequestSlots() {
  return isUsingRequestSlots;
}

export function getCanEdit() {
  return canEdit;
}

export function getUseShiftBorders() {
  return useShiftBorders;
}

// closeSectionDraw will remove classes and temporary DOM elements for the draw section feature.
export function closeSectionDraw() {
  draw.close();
}

export function resizeSlotsForUser(userId) {
  if (!userId) {
    return;
  }
  resizeSlotDOMElementsForUser(userId);
}

function showDataLoadingMsg() {
  $("#slots-dws-spinner").show();
}

export function hideDataLoadingMsg() {
  $("#slots-dws-spinner").hide();
}

export function handleUpdateSlotUnreadCommentBadge(slotId, numComments = 0) {
  updateSlotUnreadCommentBadge(slotId, numComments);
}

function mountAutoModal(props, meStore, roles) {
    const app = createApp(AutoModal, {
    roles: roles,
    timePeriodType: "day",
    tags: props.tags,
    activeDate: props.pipelineDates[0].String,
    isDailyAuto: true,
    meStore: meStore
  });
  window[MODAL_ID.AUTO_MODAL] = app.mount(MODAL_ID.AUTO_MODAL)
  $(`${MODAL_ID.AUTO_MODAL}-btn`).on("click", () => {
    window[MODAL_ID.AUTO_MODAL].openModal();
  })
}

function initShiftBorders() {
  if (!useShiftBorders) {
    return;
  }

  // Add dashed border to unlocked slots
  document.querySelectorAll('.slot[data-locked="false"]').forEach(el => {
    el.classList.add('slot-dashed-border');
  });

  // Remove checkmarks
  document.querySelectorAll('.confirm-checkmark').forEach(el => {
    el.classList.add('d-none');
  });
}

function setCalendarModal() {
  const modal = $("#calendar-modal");
  if (modal.length) {
    $("#calendar-btn-dropdown").click(() =>  modal.show());
  }
}

export function initRoleSectionBulkDeleteEvent(urlParams) {
  const autoDelBtn = document.getElementById("role-section-auto-bulk-delete");
  if (autoDelBtn) {
    autoDelBtn.addEventListener("click", () => {
      alertModal.confirm("確定していない「自動作成したシフト」が全て削除されますがよろしいですか？", () => {
        roleSectionAutoBulkDelete(urlParams, true)
      })
    })
  }

  const allDelBtn = document.getElementById("role-section-all-bulk-delete");
  allDelBtn.addEventListener("click", () => {
    alertModal.confirm('現在画面に表示されている" 全て "のシフトデータが削除されますがよろしいですか？　＊一度削除するとこのアクションは取り消せません。先にExcelダウンロードでバックアップすることをオススメします。＊', () => {
      roleSectionAutoBulkDelete(urlParams, false)
    })
  })

  const selectDelBtn = document.getElementById("role-section-select-bulk-delete");
  selectDelBtn.addEventListener("click", () => {
    toggleDeleteMode(true);
  })

  const cancelSelected = document.getElementById("selected-role-cancel");
  cancelSelected?.addEventListener("click", () => {
    toggleDeleteMode(false);
  })

  const confirmSelected = document.getElementById("selected-role-confirm");
  confirmSelected?.addEventListener("click", () => {
    const num = Object.keys(deleteMode.selectedIds).length;
    if (num === 0) {
      alertModal.alert("削除するシフトが選択されていません。")
      return;
    }
    alertModal.confirm(`現在画面に表示されている" 選択中（${num}） "のシフトデータが削除されますがよろしいですか？　＊一度削除するとこのアクションは取り消せません。先にExcelダウンロードでバックアップすることをオススメします。＊`, async () => {
      await handleRoleSectionSelectDelete()
    })
  })
}

async function handleRoleSectionSelectDelete() {
  try {
    const sectionIds = Object.keys(deleteMode.selectedIds).map(Number);
    if (sectionIds.length === 0) {
      return;
    }
    $(".dws-delete-btn").addClass("loading")
    const response = await summaryUndoDwsAuto(activeUserId, activeCompany.ID, { sectionIds })
    onBulkDelete(response);
    toggleDeleteMode(false);
  } catch(err) {
    alertModal.alert(ERRORS.SLOT.DELETE)
  } finally {
    $(".dws-delete-btn").removeClass("loading")
  }
}

async function roleSectionAutoBulkDelete(urlParams, autoOnly) {
  try {
    const params = {
      branchId: activeCompany.ID,
      tags: urlParams.tags,
      roles: urlParams.roles,
      date: urlParams.date,
      autoOnly: autoOnly
    }
    const response = await summaryDwsRoleSectionBulkDelete(activeUserId, params);
    onBulkDelete(response)
  } catch(err) {
    alertModal.alert(ERRORS.SLOT.DELETE)
  }
}

function onBulkDelete(response) {
  response?.sectionIDs.forEach(sectionId => {
    removeSectionFromSlotMap(sectionId);
  })
  response?.slotIDs.forEach(sId => {
    const s = SlotMap[sId];
    if (!s) {
      return;
    }
    handleSlotChange(s)
    handleNewSlot(s)
  })
  window.sessionStorage.removeItem("autoSectionIds");
  disableAutoUndoButton();
}

function toggleDeleteMode(isToggled) {
  deleteMode.isOn = isToggled;
  deleteMode.selectedIds = {};
  updateSelectedSlotsCount();
  $("#summary").removeClass("edit");
  if (isToggled) {
    $(".summary-controls.delete-controls").removeClass("d-hide");
    $(".main-controls").addClass("d-hide");
    $("#menu-delete").removeClass("active");
  } else {
    $(".main-controls").removeClass("d-hide");
    $(".summary-controls.delete-controls").addClass("d-hide");
    $(".section.selected-dws-delete").removeClass("selected-dws-delete")
  }
}

function toggleSectionForDelete(sectionId) {
  const sectionEl = document.getElementById(`slot-${sectionId}`);
  if (!sectionEl) {
    return;
  }

  sectionEl.classList.toggle("selected-dws-delete");
  deleteMode.selectedIds[sectionId] = {}

  if (!sectionEl.classList.contains("selected-dws-delete")) {
    delete deleteMode.selectedIds[sectionId]
  }
  updateSelectedSlotsCount();
}

export function updateSelectedSlotsCount() {
  const text = document.getElementById("delete-slot-count");
  const count = Object.keys(deleteMode.selectedIds).length;
  return text.innerText = count;
}

export function openDwsSectionModal(sectionId) {
  if (deleteMode.isOn) {
    toggleSectionForDelete(sectionId);
    return;
  }
  $("#section-modal-from").removeClass("is-error");
  $("#section-modal-to").removeClass("is-error");

  if (!sectionId) {
    // Not used yet
    $("#section-delete-btn").hide();
    $("#section-modal").attr("data-parentID", SlotModal.slot.ID);
    $("#section-modal").attr("data-date", SlotModal.slotDate);
  }
  const section = SlotMap[sectionId];
  if (!section) {
    alertModal.alert(ERRORS.SECTION.NOT_FOUND);
    return;
  }
  $("#section-delete-btn").show();
  $("#section-modal-purpose").val(section.Purpose);
  const fromDate = fromOplusTime(new Date(section.From));
  const from = DateTime.fromJSDate(fromDate).toFormat("HH:mm")
  const toDate = fromOplusTime(new Date(section.To));
  const to = DateTime.fromJSDate(toDate).toFormat("HH:mm")

  if (!section.HideFrom) {
    $("#section-modal-from").val(from);
  }
  if (!section.HideTo) {
    $("#section-modal-to").val(to);
  }
  if (section.RoleID) {
    $(`#section-modal-role-${section.RoleID}`).addClass("active");
  }
  if (section.Type === 4) {
    $("#section-modal-rest").prop("checked", true);
    $(".non-rest-role").hide();
  }
  selectColorBox(section.Color, 'section');
  // need to refactor these, we shouldn't rely on html's data attr for getting state
  $("#section-modal").attr("data-id", sectionId);
  $("#section-modal").attr("data-parentID", section.SectionParent);
  $("#section-modal").attr("data-date", section.Date);
  $("#section-modal-memo").val(section.Memo);
  $("#section-modal").addClass("active");
}

function removeSectionFromSlotMap(sectionId) {
  const section = SlotMap?.[sectionId]
  if (!section) {
    return;
  }

  const parent = SlotMap[section.SectionParent]
  const slotModalSections = SlotModal?.slot?.Sections;
  if (!parent) {
    return;
  }

  const deletedSectIdx = parent?.Sections?.indexOf(parseInt(sectionId));
  if (deletedSectIdx > -1) {
    parent.Sections.splice(deletedSectIdx, 1);
  }
  const index = parent.SectionSlots.findIndex(s => s.ID == sectionId);
  if (index > -1) {
    parent.SectionSlots.splice(index, 1);
  }

  if (!slotModalSections) {
    return;
  }

  const deletedSectionIndex = slotModalSections.findIndex(sId => sId == sectionId);
  if (deletedSectionIndex > -1) {
    slotModalSections.splice(deletedSectionIndex, 1);
  }
}

export function updateSlotMapSections(sections) {
  sections?.forEach(section => {
    SlotMap[section.ID] = section;
  });
}

export function mountSummaryDateNavView(props) {
  const app = createApp(SummaryDateNavView);
  const viewModel = ref({
    activeCompanyID: props.pipelineActiveCompany.ID,
    activeUserID: props.activeUserID,
    startDate: getTableStartDate(),
    endDate: getTableStartDate(),
    timePeriodType: "day",
    currentPage: "summary",
    showDailyButton: true,
    tags: props.tags || [],
    roles: props.roles,
    hasPro: props.hasPro,
    hasTag: props.hasTagPerm,
    canEdit: props.pipelineCanEdit,
    isDWS: true,
    workerOnly: isQueryParamTrue("workerOnly"),
    lockedOnly: isQueryParamTrue("lockedOnly"),
  })

  app.provide(dateNavViewModelInjectKey, readonly(viewModel));
  app.use(i18n);
  app.mount("#summary-date-nav-view");
}

//initPage will initialize all necessary global variables, DOM elements, and components for the page.
export function initPage(props) {
  const localTimeZone = "Asia/Tokyo";
  const user = new User({id: props.activeUserID});
  const meStore = new MeStore({user}, {activeBranchId: props.pipelineActiveCompany.ID.toString(), activeGroupId: props.activeGroupID.toString()});
  meStore.setTimeZone(localTimeZone);
  setMeStore(meStore);
  readSlots(SlotMap, props.activeUserID);
  showDataLoadingMsg()
  // TODO: set the global dates param here when refactor merged in
  slotUrl = props.url;
  activeUserId = props.activeUserID;
  activeCompany = transformCompany(props.pipelineActiveCompany);
  isUsingRequestSlots = props.pipelineActiveBranchSettings.StackRequestSlots
  initSlotModalRoleListComponent(activeCompany.ID)
  userIds = (props.users || []).map(user => String(user.ID));

  canEdit = props.pipelineCanEdit;
  useShiftBorders = props.useShiftBorders;
  // as of 2023-12-06 DashURL function is in dashboard_base.html line 4602
  slot_crud.initSlotCrud(false, DashURL("slot"));
  getPageSlotURL(DashURL("slot"));
  if (props.tags) {
    props.tags = sortTags(props.tags);
  }
  initTable(props);
  initAutoUndoButton(meStore);
  initUndoButton({ activeUserId, activeBranchId: activeCompany.ID });
  initShiftBorders();
  mountSummaryDateNavView(props);

  const roles = roleStore.query({ filterRoleSection: true, isRoleSection: true })
  mountAutoModal(props, meStore, roles);
  initDwsCellEdit(canEdit, props.viewType);
  if (props.hasAutoPerm) {
    const startDate = getTableStartDate();
    const modalProps = {
      ...props,
      timePeriodType: periodTypes.DAY,
      activeDate: props.urlParams.date,
      urlParams: {
        ...props.urlParams,
        until: props.urlParams.date,
      },
    };

    mountAutoAIModal(modalProps, roles, startDate, startDate, props.tags, meStore);
    initFooterAutoButtonClick();
  }

  setCalendarModal();
  initRoleSectionBulkDeleteEvent(props.urlParams)
  initFooterDropdownHandlers();
}
